import React, { useState, useRef, useEffect } from "react";
import "./RaiseBill.scss";

// Simple test component to debug EditableField issues
const TestEditableField = () => {
  // State for the form
  const [personName, setPersonName] = useState("John Doe");
  const [category, setCategory] = useState("Test Category");
  const [editingField, setEditingField] = useState(null);
  const [isDraggingDisabled, setIsDraggingDisabled] = useState(false);

  // Force readOnly to false for testing
  const readOnly = false;

  // Editable field component from RaiseBill
  const EditableField = ({
    id,
    value,
    onChange,
    isNumeric = false,
    className = "",
  }) => {
    const isEditing = editingField === id && !readOnly;
    const inputRef = useRef(null);
    const [localValue, setLocalValue] = useState(value);
    const [hasFocus, setHasFocus] = useState(false);

    // Update local value when external value changes, but only if not editing
    useEffect(() => {
      if (!hasFocus) {
        setLocalValue(value);
      }
    }, [value, hasFocus]);

    // When entering edit mode, focus on the input field
    useEffect(() => {
      if (isEditing && inputRef.current) {
        setHasFocus(true);
        inputRef.current.focus();
        setIsDraggingDisabled(true);
      } else if (!isEditing && editingField === id) {
        setIsDraggingDisabled(false);
        setHasFocus(false);
      }
    }, [isEditing, id]);

    const handleClick = (e) => {
      console.log(`Field ${id} clicked!`);

      if (readOnly) {
        console.log(`Field ${id} is read-only, ignoring click`);
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (!isEditing) {
        console.log(`Setting editing field to ${id}`);
        setEditingField(id);
      }
    };

    const handleInputChange = (e) => {
      e.preventDefault();
      e.stopPropagation();
      let newValue = e.target.value;
      setLocalValue(newValue);
      onChange(newValue);
    };

    const handleBlur = () => {
      console.log(`Field ${id} blur event`);
      setEditingField(null);
      setHasFocus(false);
    };

    return (
      <div
        className={`editable-field ${className} ${isEditing ? "editing" : ""}`}
        onClick={handleClick}
        data-field-id={id}
        style={{
          border: "1px solid #ccc",
          padding: "8px",
          margin: "5px 0",
          cursor: "pointer",
        }}
      >
        {isEditing ? (
          <input
            ref={inputRef}
            type="text"
            value={localValue}
            onChange={handleInputChange}
            onBlur={handleBlur}
            style={{
              width: "100%",
              padding: "5px",
            }}
          />
        ) : (
          <div className="field-content">{value}</div>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "20px auto",
        padding: "20px",
        border: "1px solid #ddd",
      }}
    >
      <h2>Test Editable Field</h2>
      <p>Click on any field to edit it</p>

      <div style={{ marginBottom: "20px" }}>
        <h3>Person Details</h3>
        <div>
          <div>Person Name</div>
          <EditableField
            id="person.name"
            value={personName}
            onChange={(value) => setPersonName(value)}
          />
        </div>

        <div>
          <div>Category</div>
          <EditableField
            id="person.category"
            value={category}
            onChange={(value) => setCategory(value)}
          />
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <h3>Current State:</h3>
        <pre>
          {JSON.stringify(
            {
              personName,
              category,
              editingField,
              readOnly,
            },
            null,
            2
          )}
        </pre>
      </div>
    </div>
  );
};

export default TestEditableField;
